<div class="component-favorite-reports" *ngIf="showFavoriteComponent">
  <div class="element-padding">
    <h3>Favorites - {{userNiceName}}</h3>
    <p>Want to log out? Click <a href="#" (click)="logOutUser($event)"><strong>here</strong></a>.</p>
    <p *ngIf="allData.length === 0">You don't have any favorites. Try adding some.</p>
  </div>
  <app-single-report-small [allData]="allData" [showEmptyIcon]="false"></app-single-report-small>
</div>
